import React, { useContext, useState } from 'react';
import './Balance.css';
import { AsgAppContext, AsgDictionaryContext } from '../../contexts';
import { BalanceFold } from '../../../../shared/src/components/BalanceFold';

export const Balance = ({
    text,
    className = '',
}) => {
    const AsgApp = useContext(AsgAppContext);
    const dictionary = useContext(AsgDictionaryContext);
    const [isBalanceFoldVisible, setIsBalanceFoldVisible] = useState(false);

    const showBalanceFold = () => {
        setIsBalanceFoldVisible(true);
    };

    const hideBalanceFold = () => {
        setIsBalanceFoldVisible(false);
    };

    return <div
        className={`statusbar__balance-wrap ${className}`}
        onMouseEnter={showBalanceFold}
        onMouseLeave={hideBalanceFold}
    >
        <div className="text-wrapper statusbar__balance">{text}</div>
        <div className={`statusbar__balance-fold ${isBalanceFoldVisible
            ? 'statusbar__balance-fold--active' : ''}`}>
            <BalanceFold
                amounts={AsgApp.getBalanceFoldData()}
                buttons={[
                    {
                        text: dictionary.translate('cashout'),
                        handler: AsgApp.showWithdraw,
                    }
                ]}
            />
        </div>
    </div>;
};
